import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Francis Gamache - Location d'équipement</p>
        <img src="/7127.jpg" alt="logo" />
        <p>Site Web en construction</p>
      </header>
    </div>
  );
}

export default App;
